export * from './adminController.service';
import { AdminControllerService } from './adminController.service';
export * from './authController.service';
import { AuthControllerService } from './authController.service';
export * from './registrationController.service';
import { RegistrationControllerService } from './registrationController.service';
export * from './usersController.service';
import { UsersControllerService } from './usersController.service';
export const APIS = [AdminControllerService, AuthControllerService, RegistrationControllerService, UsersControllerService];
